import {
	ACTIVE_CLASS,
	NAVBAR_DROPDOWN_ITEM,
	NAV_ITEM,
	NAV_LIST,
	VISIBLE_CLASS,
	NAVBAR_DROPDOWN_LABEL, NAVBAR_DROPDOWN_LIST
} from "constants/shared/headerSelectors";

export const navbarItemsHandler = (setIsCorporateHatOpen: (isCorporateHatOpen: boolean) => void,
								   setCorpHatAccordionStates: (corpHatAccordionStates: boolean[]) => void) => {
	const openItemNav = (e: Event) => {
		e.stopPropagation();
		const target = e.target as HTMLElement;
		const currentNavItem = target.closest(`.${NAV_ITEM}`);
		if (currentNavItem) {
			resetOtherActiveNavItems(currentNavItem);
			setIsCorporateHatOpen(false);
			setCorpHatAccordionStates([false, false]);

			currentNavItem.classList.toggle(ACTIVE_CLASS);
		}
	};
	const navbarItems = document.querySelectorAll(`.${NAV_LIST} .${NAV_ITEM}`);
	navbarItems.forEach((item) => {
		item?.addEventListener("click", (e) => openItemNav(e));
	});

	const openSubNavItem = (e: Event) => {
		e.stopPropagation();
		const target = e.target as HTMLElement;
		const currentSubNavItem = target.closest(`.${NAVBAR_DROPDOWN_ITEM}`);
		if (currentSubNavItem){
			resetOtherActiveSubNavItems(currentSubNavItem);
			currentSubNavItem.classList.toggle(ACTIVE_CLASS);
		}
	};
	const navbarSubItems = document.querySelectorAll(`.${NAVBAR_DROPDOWN_LIST} > .${NAVBAR_DROPDOWN_ITEM} > .${NAVBAR_DROPDOWN_LABEL}`);
	navbarSubItems.forEach((item) => {
		item?.addEventListener("click", (e) => openSubNavItem(e));
	});
};

export const resetOtherActiveSubNavItems = (current: Element) => {
	const subNavItems = Array.prototype.slice.call(document.querySelectorAll(`.${NAVBAR_DROPDOWN_ITEM}`));
	findNavItemsExceptCurrent(subNavItems, current);
	subNavItems.forEach(element => {
		if (element.classList.contains(ACTIVE_CLASS)) {
			element.classList.remove(ACTIVE_CLASS);
		}
	});
}


export const resetOtherActiveNavItems = (current: Element) => {
	const navItems: Element[] = Array.prototype.slice.call(document.querySelectorAll(`.${NAV_ITEM}`));
	findNavItemsExceptCurrent(navItems, current);
	navItems.forEach((element) => {
		if (element.classList.contains(ACTIVE_CLASS)) {
			let subElements = element.querySelectorAll(`.${NAVBAR_DROPDOWN_ITEM}`);
			if (subElements != null && subElements.length > 0) {
				subElements.forEach((x) => x.classList.remove(VISIBLE_CLASS));
			}
			element.classList.remove(ACTIVE_CLASS);
		}
	});
};

export const resetAllActiveNavItems = () => {
	// Reset all NAV_ITEM elements
	const navItems: Element[] = Array.prototype.slice.call(document.querySelectorAll(`.${NAV_ITEM}`));
	navItems.forEach((element) => {
		if (element.classList.contains(ACTIVE_CLASS)) {
			element.classList.remove(ACTIVE_CLASS);
		}
	});

	// Reset all NAVBAR_DROPDOWN_ITEM elements
	const subNavItems: Element[] = Array.prototype.slice.call(document.querySelectorAll(`.${NAVBAR_DROPDOWN_ITEM}`));
	subNavItems.forEach((element) => {
		if (element.classList.contains(ACTIVE_CLASS)) {
			element.classList.remove(ACTIVE_CLASS);
		}
	});
}

const findNavItemsExceptCurrent = (navItems: Element[], current: Element) => {
	if (navItems != null && navItems.length > 0) {
		const currentSelectedItemPos = navItems.findIndex((x) => x === current);
		navItems.splice(currentSelectedItemPos, 1);
	}
};

